export const WAREHOUSE_EN = {
  true: 'ACTIVE',
  false: 'INACTIVE',
  soldToAddress: 'Sold To Address',
  shipToAddress: 'Ship To Address',
  operationType: 'Operation Type',
  ownerInformation: 'Owner Information',
}
